document.addEventListener("DOMContentLoaded", () => {
    const showMoreButton = document.getElementById('show-more-remotes');
    const remoteItems = document.querySelectorAll('.product-remote-items li');

    if (showMoreButton) {
        showMoreButton.addEventListener('click', () => {
            remoteItems.forEach((item) => {
                item.classList.remove('hidden');
            });

            showMoreButton.remove();
        })
    }

});
